export type BillingSection = 'plans' | 'credits' | 'transactions';

/** Keep saved purchase links usable without putting pricing back in onboarding. */
export function getBillingSection(search: string): BillingSection {
  const params = new URLSearchParams(search);
  const section = params.get('section');
  if (section === 'plans' || section === 'credits' || section === 'transactions') return section;
  if (params.get('checkout_flow') === 'credits' || params.get('credit_package')?.trim()) return 'credits';
  return 'plans';
}
